import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block text-sm font-medium leading-6 text-dark-blue" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = ["type", "placeholder", "value", "required", "disabled", "readonly"]
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 text-sm mt-1"
}




export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
  modelValue: String,
  label: String,
  placeholder: String,
  type: {
    type: String,
    default: 'text'  // Allows use as various types of inputs
  },
  errorMessage: String,
  required: Boolean,
  styleClass: String,  // Accept class for external styling
  disabled: Boolean,
  readonly: Boolean
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.styleClass)
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: __props.type,
        placeholder: __props.placeholder,
        value: __props.modelValue,
        required: __props.required,
        disabled: __props.disabled,
        readonly: __props.readonly,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        class: "block w-full rounded-md border-0 py-1.5 px-2 text-dark-blue shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6 outline-none"
      }, null, 40, _hoisted_3),
      (__props.errorMessage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})